import { useTranslation } from 'react-i18next';

const LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'od', label: 'ଓଡ଼ିଆ' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'te', label: 'తెలుగు' },
  { code: 'kn', label: 'ಕನ್ನಡ' },
];

export function LanguageSelector({ compact }: { compact?: boolean }) {
  const { i18n } = useTranslation();

  const change = (lang: string) => {
    i18n.changeLanguage(lang);
    localStorage.setItem('i18n_lang', lang);
  };

  if (compact) {
    return (
      <select
        className="lang-selector-compact"
        value={i18n.language}
        onChange={(e) => change(e.target.value)}
      >
        {LANGUAGES.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    );
  }

  return (
    <div className="lang-selector">
      {LANGUAGES.map((l) => (
        <button
          key={l.code}
          className={`lang-btn ${i18n.language === l.code ? 'lang-active' : ''}`}
          onClick={() => change(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
